import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const LineChartIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z" fill="currentColor" />
  </svg>
);

LineChartIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(LineChartIcon);
